module.exports = __webpack_public_path__ + "static/og-dfe80d40845adb1be77163cbae3506ff.png";